var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_vm.partner ? _c('v-container', [_c('paginated-table', {
    attrs: {
      "store": _vm.store,
      "headers": _vm.headers,
      "baseQuery": {
        partnerId: _vm.partnerId
      },
      "controlElements": _vm.controlElements,
      "title": _vm.$t('partner.ActivityLogTable.title')
    },
    scopedSlots: _vm._u([{
      key: "item.timestamp.created",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
      }
    }, {
      key: "item.user.userName",
      fn: function fn(_ref2) {
        var _item$user;

        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.userName) + " ")];
      }
    }, {
      key: "item.source.refType",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.$t("BackendResourceEnum.".concat(item === null || item === void 0 ? void 0 : item.source.refType))) + " ")];
      }
    }, {
      key: "item.actionType",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$t("partner.ActivityLogTable.actionType.".concat(item === null || item === void 0 ? void 0 : item.actionType))) + " ")];
      }
    }], null, false, 871453546)
  })], 1) : _c('v-container', [_c('v-skeleton-loader')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }